import { motion } from "framer-motion";
import { Apple, Play } from "lucide-react";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/lib/site";

const ease = [0.16, 1, 0.3, 1];

const StoreButton = ({ store, icon: Icon, testId }) => (
  <a
    href={store === "App Store" ? APP_STORE_URL : GOOGLE_PLAY_URL}
    data-testid={testId}
    title={`Download Pull Up on the ${store}`}
    className="group flex items-center gap-3 rounded-2xl bg-[#141A18] border border-white/10 px-6 py-3.5 hover:border-[#4FE3E0]/40 hover:bg-[#18201E] transition-colors duration-300"
  >
    <Icon className="w-7 h-7 text-white group-hover:text-[#4FE3E0] transition-colors duration-300" fill="currentColor" />
    <span className="text-left leading-tight">
      <span className="block text-[10px] text-zinc-400">
        {store === "App Store" ? "Download on the" : "Get it on"}
      </span>
      <span className="block font-semibold text-white">{store}</span>
      <span className="block text-[9px] font-semibold tracking-[0.2em] text-[#4FE3E0] mt-0.5">COMING SOON</span>
    </span>
  </a>
);

export const Hero = () => (
  <section data-testid="hero-section" className="relative min-h-[calc(100svh-4rem)] flex flex-col justify-center px-6 text-center overflow-hidden">
    <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_60%_45%_at_50%_0%,rgba(79,227,224,0.08),transparent)]" />

    <div className="relative max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease }}
      >
        <span
          data-testid="hero-badge"
          className="inline-block text-[11px] font-semibold tracking-[0.2em] text-[#4FE3E0] border border-[#4FE3E0]/30 bg-[#4FE3E0]/5 rounded-full px-4 py-1.5"
        >
          MEET UP IN REAL LIFE
        </span>
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 26 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.12, ease }}
        className="mt-7 font-bold tracking-tight text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.05]"
      >
        See who's out.<br />
        Make a plan. <span className="text-[#4FE3E0]">Pull up.</span>
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 22 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.24, ease }}
        data-testid="hero-subheadline"
        className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed max-w-xl mx-auto"
      >
        Pull Up is the effortless way for friends to link up at bars and nightlife.
        No endless group texts — just tap in, see who's down, and go.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 22 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.36, ease }}
        className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4"
      >
        <StoreButton store="App Store" icon={Apple} testId="hero-app-store-button" />
        <StoreButton store="Google Play" icon={Play} testId="hero-google-play-button" />
      </motion.div>
    </div>
  </section>
);
